import angular from 'angular';
import loanVariationModal from './loanVariationModal';

export default angular
  .module('scenes.loanVariationModal', [])
  .component('loanVariationModal', loanVariationModal).name;
